import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldSwitch, FlexBox, Text } from '@dixa/lib-shared-habla';
/**
 * Elevio integration state description component. When elevio is connected
 * shows a toggle to enable / disable elevio integration.
 */
export function ElevioStateDescription({ state, onToggle, }) {
    if (state.type === 'not-connected') {
        return (_jsx(Text.Paragraph, { children: "Connect your Elevio account to enable users to search and find answers in articles." }));
    }
    return (_jsxs(FlexBox, Object.assign({ justifyContent: "space-between" }, { children: [_jsx(Text.Paragraph, { children: "Show Elevio integration interface on Messenger." }), _jsx(FieldSwitch, { input: {
                    checked: state.enabled,
                    name: 'active',
                    value: 'active',
                    onChange: onToggle,
                } })] })));
}
